<ng-container [formGroup]="form">

  <app-base-field-html [form]="form" [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                       [hideField]="hideField" [scrollContainer]="scrollContainer" [inputId]="inputId"
                       (emitPush)="pushComposite(fieldData)">

<!--    @if (fieldData.kind !== 'external' && fieldData.kind !== 'paused') {-->
    <div>
      @if (fieldData.typeInfo.multiplicity) {
        <div>
          <div appSortable (positionChanged)="onPositionChanged($event)" id="sortable-container">
            @for (control of fieldAsFormArray().controls; track control; let i = $index) {
              <div id="{{i}}" [attr.data-index]="i" class="uk-width-expand uk-grid">
                <div [formGroupName]="i" class="uk-width-9-10 uk-margin-medium-left"
                     [ngClass]="{'uk-margin-bottom formGroupElement': $safeNavigationMigration(fieldData.form.display?.hasBorder)}">
                  @if (fieldAsFormArray().length > 1 && !readonly) {
                    <div class="uk-flex uk-flex-right">
                      <span class="uk-sortable-handle uk-text-center" data-uk-icon="icon: move"></span>
                    </div>
                  }
                  @for (control of fieldData?.subFields; track $index;) {
                    <div>
                      @if (!control.deprecated) {
                        <div class="">
                          @if (control.typeInfo.type === 'composite') {
                            <div>
                              <app-composite-field [fieldData]="control" [subVocabularies]="subVocabularies" [readonly]="readonly"
                                                   [vocabularies]="vocabularies" [editMode]="editMode" [position]="i"
                                                   [scrollContainer]="scrollContainer"
                                                   (hasChanges)="unsavedChangesPrompt()" (handleBitSets)="handleBitsetOfChildren($event)"
                                                   (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                              </app-composite-field>
                            </div>
                          }
                          @if (control.typeInfo.type === 'chooseOne') {
                            <div>
                              <app-choose-one [fieldData]="control" [subVocabularies]="subVocabularies" [editMode]="editMode"
                                              [vocabularies]="vocabularies" (hasChanges)="unsavedChangesPrompt()"
                                              [position]="i" (handleBitSets)="handleBitsetOfChildren($event)"
                                              (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                              </app-choose-one>
                            </div>
                          }
                          @if (fieldData.typeInfo.type === 'select') {
                            <app-select-field [fieldData]="control" [position]="i" [editMode]="editMode"
                                              [readonly]="readonly" [scrollContainer]="scrollContainer"
                                              (hasChanges)="unsavedChangesPrompt()">
                            </app-select-field>
                          }
                          @if (control.typeInfo.type === 'vocabulary') {
                            <div class="uk-form-controls uk-margin-medium-top">
                              <app-vocabulary-field [fieldData]="control" [position]="i" [editMode]="editMode"
                                                    [readonly]="readonly" [scrollContainer]="scrollContainer"
                                                    (hasChanges)="unsavedChangesPrompt()">
                              </app-vocabulary-field>
                            </div>
                          }
                          @if (control.typeInfo.type === 'string' || control.typeInfo.type === 'email'||
                               control.typeInfo.type === 'phone' || control.typeInfo.type === 'url') {
                            <div>
                              <app-string-url-email-field [fieldData]="control" [position]="i" [editMode]="editMode"
                                                          [readonly]="readonly" [scrollContainer]="scrollContainer"
                                                          (hasChanges)="unsavedChangesPrompt()"
                                                          (handleBitSets)="handleBitsetOfChildren($event)"
                                                          (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                              </app-string-url-email-field>
                            </div>
                          }
                          @if (control.typeInfo.type === 'number') {
                            <div>
                              <app-number-field [fieldData]="control" [position]="i" [editMode]="editMode" [readonly]="readonly"
                                                [scrollContainer]="scrollContainer"
                                                (hasChanges)="unsavedChangesPrompt()"
                                                (handleBitSets)="handleBitsetOfChildren($event)"
                                                (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                              </app-number-field>
                            </div>
                          }
                          @if (control.typeInfo.type === 'bool') {
                            <div>
                              <app-boolean-field [fieldData]="control" [position]="i" (hasChanges)="unsavedChangesPrompt()"
                                                 [editMode]="editMode" [readonly]="readonly"
                                                 (handleBitSets)="handleBitsetOfChildren($event)"
                                                 (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                              </app-boolean-field>
                            </div>
                          }
                          @if (control.typeInfo.type === 'checkbox') {
                            <div class="uk-form-controls">
                              <app-checkbox-field [fieldData]="control" [position]="i" (hasChanges)="unsavedChangesPrompt()"
                                                  (handleBitSets)="handleBitsetOfChildren($event)" [editMode]="editMode"
                                                  (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                              </app-checkbox-field>
                            </div>
                          }
                          @if (control.typeInfo.type === 'largeText') {
                            <div>
                              <app-large-text-field [fieldData]="control" [position]="i" [readonly]="readonly" [editMode]="editMode"
                                                    [scrollContainer]="scrollContainer"
                                                    (hasChanges)="unsavedChangesPrompt()"
                                                    (handleBitSets)="handleBitsetOfChildren($event)"
                                                    (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                              </app-large-text-field>
                            </div>
                          }
                          @if (control.typeInfo.type === 'radio') {
                            <div class="uk-form-controls">
                              <app-radio-button-field [fieldData]="control" [position]="i" [editMode]="editMode" [readonly]="readonly"
                                                      [scrollContainer]="scrollContainer"
                                                      (hasChanges)="unsavedChangesPrompt()" (handleBitSets)="handleBitsetOfChildren($event)"
                                                      (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                              </app-radio-button-field>
                            </div>
                          }
                          @if (control.typeInfo.type === 'richText') {
                            <div class="uk-form-controls">
                              <app-rich-text-field [fieldData]="control" [position]="i" [editMode]="editMode" [readonly]="readonly"
                                                   [scrollContainer]="scrollContainer"
                                                   (hasChanges)="unsavedChangesPrompt()"
                                                   (handleBitSets)="handleBitsetOfChildren($event)"
                                                   (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                              </app-rich-text-field>
                            </div>
                          }
                          @if (control.typeInfo.type === 'date') {
                            <div>
                              <app-date-field [fieldData]="control" [position]="i" [editMode]="editMode" [readonly]="readonly"
                                              [scrollContainer]="scrollContainer"
                                              (hasChanges)="unsavedChangesPrompt()"
                                              (handleBitSets)="handleBitsetOfChildren($event)"
                                              (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                              </app-date-field>
                            </div>
                          }
                          @if (control.typeInfo.type === 'scale') {
                            <div>
                              <app-scale-field [fieldData]="control" [position]="i" (hasChanges)="unsavedChangesPrompt()"
                                               (handleBitSets)="handleBitsetOfChildren($event)" [editMode]="editMode"
                                               (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                              </app-scale-field>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (fieldAsFormArray().length > 1 && !readonly) {
                  <div class="uk-width-expand uk-padding-remove uk-margin-small-top uk-grid uk-child-width-1-2">
                    <div class="">
                      <div>
                        <a (click)="move(i-1, i)"><span class="material-icons">north</span></a>
                      </div>
                      <div>
                        <a (click)="move(i+1, i)"><span class="material-icons">south</span></a>
                      </div>
                    </div>
                    <div class="uk-padding-small">
                      <a class="remove-element"
                         (click)="remove(i); updateBitSetOfComposite(fieldData, i); unsavedChangesPrompt();">
                        <span class="material-icons">clear</span>
                      </a>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
<!--            @if (!readonly) {-->
<!--              <div class="uk-width-9-10 uk-text-center uk-margin-top uk-margin-bottom">-->
<!--                <a class="add-new-element uk-flex uk-flex-middle uk-flex-center" (click)="pushComposite(fieldData)">-->
<!--                  <span class="material-icons">add</span>Add &nbsp;<span [innerHTML]="fieldData.label.text"></span>-->
<!--                </a>-->
<!--              </div>-->
<!--            }-->
        </div>
      } @else {
        <div class="uk-width-1-1 uk-display-inline-block" [ngClass]="{'uk-margin-bottom formGroupElement': $safeNavigationMigration(fieldData.form.display?.hasBorder)}">
          @for (control of fieldData?.subFields; track $index;) {
            <div>
              @if (!control.deprecated) {
                <div class="">
                  @if (control.typeInfo.type === 'composite') {
                    <div>
                      <app-composite-field [fieldData]="control" [subVocabularies]="subVocabularies" [vocabularies]="vocabularies"
                                           [editMode]="editMode" [readonly]="readonly" [scrollContainer]="scrollContainer"
                                           (handleBitSets)="handleBitsetOfChildren($event)" (hasChanges)="unsavedChangesPrompt()"
                                           (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                      </app-composite-field>
                    </div>
                  }
                  @if (control.typeInfo.type === 'chooseOne') {
                    <div>
                      <app-choose-one [fieldData]="control" [subVocabularies]="subVocabularies" [vocabularies]="vocabularies"
                                      [editMode]="editMode"
                                      (handleBitSets)="handleBitsetOfChildren($event)"
                                      (hasChanges)="unsavedChangesPrompt()"
                                      (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                      </app-choose-one>
                    </div>
                  }
                  @if (control.typeInfo.type === 'select') {
                    <app-select-field [fieldData]="control" [editMode]="editMode" [readonly]="readonly"
                                      [scrollContainer]="scrollContainer" (hasChanges)="unsavedChangesPrompt()">
                    </app-select-field>
                  }
                  @if (control.typeInfo.type === 'vocabulary') {
                    <div class="uk-form-controls uk-margin-medium-top">
                      <app-vocabulary-field [fieldData]="control" [editMode]="editMode" [readonly]="readonly"
                                            [scrollContainer]="scrollContainer"
                                            (hasChanges)="unsavedChangesPrompt()">
                      </app-vocabulary-field>
                    </div>
                  }
                  @if (control.typeInfo.type === 'string' || control.typeInfo.type === 'url' ||
                       control.typeInfo.type === 'email' || control.typeInfo.type === 'phone') {
                    <div>
                      <app-string-url-email-field [fieldData]="control" [editMode]="editMode" [readonly]="readonly"
                                                  [scrollContainer]="scrollContainer"
                                                  (hasChanges)="unsavedChangesPrompt()"
                                                  (handleBitSets)="handleBitsetOfChildren($event)"
                                                  (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                      </app-string-url-email-field>
                    </div>
                  }
                  @if (control.typeInfo.type === 'number') {
                    <div>
                      <app-number-field [fieldData]="control" [editMode]="editMode" [readonly]="readonly"
                                        [scrollContainer]="scrollContainer"
                                        (hasChanges)="unsavedChangesPrompt()"
                                        (handleBitSets)="handleBitsetOfChildren($event)"
                                        (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                      </app-number-field>
                    </div>
                  }
                  @if (control.typeInfo.type === 'bool') {
                    <div>
                      <app-boolean-field [fieldData]="control" [editMode]="editMode" [readonly]="readonly"
                                         [scrollContainer]="scrollContainer"
                                         (hasChanges)="unsavedChangesPrompt()"
                                         (handleBitSets)="handleBitsetOfChildren($event)"
                                         (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                      </app-boolean-field>
                    </div>
                  }
                  @if (control.typeInfo.type === 'checkbox') {
                    <div class="uk-form-controls">
                      <app-checkbox-field [fieldData]="control" [editMode]="editMode"
                                          (hasChanges)="unsavedChangesPrompt()"
                                          (handleBitSets)="handleBitsetOfChildren($event)"
                                          (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                      </app-checkbox-field>
                    </div>
                  }
                  @if (control.typeInfo.type === 'largeText') {
                    <div class="uk-form-controls">
                      <app-large-text-field [fieldData]="control" [readonly]="readonly" (hasChanges)="unsavedChangesPrompt()"
                                            [editMode]="editMode" [scrollContainer]="scrollContainer"
                                            (handleBitSets)="handleBitsetOfChildren($event)"
                                            (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                      </app-large-text-field>
                    </div>
                  }
                  @if (control.typeInfo.type === 'richText') {
                    <div class="uk-form-controls">
                      <app-rich-text-field [fieldData]="control" [editMode]="editMode" [readonly]="readonly"
                                           [scrollContainer]="scrollContainer"
                                           (hasChanges)="unsavedChangesPrompt()"
                                           (handleBitSets)="handleBitsetOfChildren($event)"
                                           (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                      </app-rich-text-field>
                    </div>
                  }
                  @if (control.typeInfo.type === 'radio') {
                    <div class="uk-form-controls">
                      <app-radio-button-field [fieldData]="control" [editMode]="editMode" [readonly]="readonly"
                                              [scrollContainer]="scrollContainer"
                                              (hasChanges)="unsavedChangesPrompt()"
                                              (handleBitSets)="handleBitsetOfChildren($event)"
                                              (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                      </app-radio-button-field>
                    </div>
                  }
                  @if (control.typeInfo.type === 'date') {
                    <div>
                      <app-date-field [fieldData]="control" [editMode]="editMode" [readonly]="readonly"
                                      [scrollContainer]="scrollContainer"
                                      (hasChanges)="unsavedChangesPrompt()"
                                      (handleBitSets)="handleBitsetOfChildren($event)"
                                      (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                      </app-date-field>
                    </div>
                  }
<!--                    @if (control.typeInfo.type === 'radioGrid') {-->
<!--                      <div>-->
<!--                        <app-radio-grid [fieldData]="control">-->
<!--                        </app-radio-grid>-->
<!--                      </div>-->
<!--                    }-->
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
<!--    }-->

  </app-base-field-html>
</ng-container>

<!--<pre>{{ form.value | json }}</pre>-->
